import React from 'react';
import type { ServicesInsightsReport } from 'model/ServicesInsightsReport';
import NetSalesServicesBarChart from './charts/NetSalesServicesBarChart';

interface Props {
    loading: boolean;
    report: ServicesInsightsReport;
}

export const ServiceInsightsCharts: React.FC<Props> = ({ loading, report }) => {
    return (
        <NetSalesServicesBarChart
            loading={loading}
            report={report}
        />
    );
};

export default ServiceInsightsCharts;
